export default "__VITE_ASSET__CB9VT4lV__"